import React, { ChangeEvent, memo, useRef, useState } from 'react';
import cn from 'classnames';
import cls from './DnD.module.css';
import { Icon } from 'shared/ui';
import { AttachmentsList } from '../AttachmentsList';
import { ContextMenu } from '../ContextMenu';
import { IModalAttachment } from '../../../../entities/attachment/model/IModalAttachment.interface';
import { IAttachmentResponse } from '../../../../entities/task/model/types/tasks';
import { useTranslation } from 'react-i18next';

//todo прокинь ActiveMenu как children и управляй им из компонента выше

interface DnDProps {
    attachments: (IModalAttachment | IAttachmentResponse)[];
    classes?: string;
    button?: string | null;
    canDelete: boolean;
    children?: React.ReactNode;
    isFileOver: boolean;
    handleDelete: (fileId: string) => void;
    onDropHandler: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragEnterHandler: (e: React.DragEvent<HTMLDivElement>) => void;
    onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleFileItemClick: (e: React.SyntheticEvent, fileId: string) => void;
    isDisabled?: boolean;
    isTaskChecked?: boolean;
    isDisabledForAdd?: boolean;
    setFileIdToDeleteFromList?: React.Dispatch<React.SetStateAction<string>>;
}

interface IMenuPosition {
    x: number;
    y: number;
}

export const DnD = memo(
    ({
        attachments,
        classes,
        canDelete,
        children,
        handleDelete,
        isFileOver,
        onDropHandler,
        onInputChange,
        onDragEnterHandler,
        isDisabled = false,
        isTaskChecked = false,
        isDisabledForAdd = false,
        setFileIdToDeleteFromList,
        handleFileItemClick,
    }: DnDProps) => {
        const { t } = useTranslation();
        const containerRef = useRef<HTMLDivElement>(null);
        const fileInputRef = useRef<HTMLInputElement | null>(null);
        const [activeMenu, setActiveMenu] = useState<{
            fileId: string | null;
            position: IMenuPosition;
        }>({
            fileId: null,
            position: { x: 0, y: 0 },
        });

        const handleOpenMenu = (fileId: string, position: IMenuPosition) => {
            setActiveMenu({ fileId, position });
            setFileIdToDeleteFromList(fileId);
        };

        const handleCloseMenu = () => {
            setActiveMenu({ fileId: null, position: { x: 0, y: 0 } });
        };

        const handleDnDClick = () => {
            if (isDisabled) return;
            fileInputRef.current?.click();
        };

        return (
            <div
                onDragEnter={onDragEnterHandler}
                className={cn(cls.DnD, isFileOver && cls.onDragOver, [classes])}
                onClick={handleDnDClick}
                onDrop={onDropHandler}
                ref={containerRef}
            >
                {children}

                {attachments.length === 0 && (
                    <div className={cn(cls.ActiveUploadArea)}>
                        <div className={cls.addFilesTitleWrapper}>
                            <Icon iconName="fileInput" className={cls.fileInputIcon} />
                            <div className={cls.addFileTitle}>
                                {isFileOver && t('Tasks.ModalFileUploader.DnD.isFileOver.text')}
                                {!isFileOver &&
                                    !isDisabled &&
                                    t('Tasks.ModalFileUploader.DnD.AddFile.text')}
                                {!isFileOver &&
                                    isDisabled &&
                                    t('Tasks.ModalFileUploader.DnD.noFiles.text')}
                                {/*{isFileOver ? 'Отпустите для загрузки' : 'Добавить файл'}*/}
                            </div>
                        </div>
                    </div>
                )}

                <input
                    ref={fileInputRef}
                    type="file"
                    style={{ display: 'none' }}
                    multiple
                    onChange={onInputChange}
                />

                {attachments.length > 0 && (
                    <AttachmentsList
                        attachments={attachments}
                        isFileOver={isFileOver}
                        handleOpenMenu={handleOpenMenu}
                        handleCloseMenu={handleCloseMenu}
                        handleFileItemClick={handleFileItemClick}
                        containerRef={containerRef}
                        activeMenuFileId={activeMenu.fileId}
                        AddFileInput={
                            isDisabledForAdd ? null : (
                                <li
                                    className={cn(
                                        cls.addFilesInputWrapperToList,
                                        attachments.length % 2 === 0 && cls.fullWidthInGrid
                                    )}
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <Icon
                                        iconName="fileInput"
                                        className={cls.fileInputIcon}
                                        width={14}
                                        height={14}
                                    />
                                    <span className={cn(cls.addFileTitle, cls.addFileTitleToList)}>
                                        {/*{isFileOver ? 'Отпустите для загрузки' : 'Добавить файл'}*/}
                                        {t('Tasks.ModalFileUploader.DnD.AddFile.text')}
                                    </span>
                                </li>
                            )
                        }
                    />
                )}

                {activeMenu.fileId && (
                    <ContextMenu
                        position={activeMenu.position}
                        onClose={handleCloseMenu}
                        fileId={activeMenu.fileId}
                        handleDelete={handleDelete}
                        canDelete={canDelete}
                        isTaskChecked={isTaskChecked}
                    />
                )}
            </div>
        );
    }
);
